import React, { useEffect, useMemo, useRef, useState } from 'react'
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import debounce from 'lodash.debounce';
import axios from 'axios'
import { Helmet } from 'react-helmet';
import { Button, Card, ColorPicker, Container, Input, InputWrapper } from '../../Components';
import { useDispatch, useSelector } from 'react-redux';
import { updateOrganizationPages, updateOrganizationPagesByID, updateUserOrganizationPageByID } from '../../Redux/features/authSlice';
import { TwitterPicker  } from 'react-color'
import { StatusPageContentDemo } from '../Statuspages/StatusPageContentDemo';
import { ReactComponent as Browserbar } from '../../assets/images/google-chrome-browser-light.svg'

export function PageSettingsTheme() {

	const regex_validator = {
		colorHex : /^\#[0-9a-zA-Z]{6,20}$/,
		
	}

	const { page_id } = useParams();
	const navigate = useNavigate();
	const effectCalled = useRef(false)
	const { user , org } = useSelector((state) => state.auth)
	const dispatch = useDispatch();

	const [isLoading, setIsLoading] = useState(false)
	const [isLoadingStatuspageData, setIsLoadingStatuspageData] = useState(false)
	const [isCheckingSubdomain, setIsCheckingSubdomain] = useState(false)
	const [displayColorPicker, setDisplayColorPicker] = useState(false)
	const [formData, setFormData] = useState({
		name: '',
		subdomain : '',
		custom_domain : '',
		background_color: "#0013ce",
		header_text_color: "#ffffff",
		logo: "",
		favicon: "",
	});
	const [formValidation, setFormValidation] = useState({
		background_color : '',
		header_text_color : ''
	})


	useEffect(() => {

		if(effectCalled.current){ return ;}
		 
		async function fetchData() {
			
			await getStatuspageData();
		}
		fetchData();

		effectCalled.current = true ;
	  
	}, [])



	/**
	 * 
	 * @returns 
	 */
	const getStatuspageData = () => {

		return new Promise(async(resolve, reject) => { 

			setIsLoadingStatuspageData(true)
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = { }

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					setFormData( (prevState) => ({ 
						...prevState,
						background_color: data?.background_color ?? '',
						header_text_color: data?.header_text_color ?? '',
						logo: data?.logo?? '',
						favicon: data?.favicon ?? '',
						name: data?.name ?? '',
						subdomain : data?.subdomain ?? '',
						custom_domain : data?.custom_domain ?? '',
						
					}))

					 
					 

					setIsLoadingStatuspageData(false)
		
					resolve(data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
                    if(error?.response?.data?.error ==='NOT_FOUND'){
						navigate('/pages')
					}
					setIsLoadingStatuspageData(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}
				})
			}else{
				setIsLoadingStatuspageData(false)
			}

		})
	} 

	 

	/**
	 * 
	 * @param {*} e 
	 * @returns 
	 */
	const onSubmit = async (e) => {
		e.preventDefault();

		return new Promise( async (resolve, reject) => { 
			
			setIsLoading(true)
			let validationBackgroundColor = ''// (formData.hosted_subdomain.match(regex_validator.subdomain)===null) ? 'Invalid subdomain, must only include letters, numbers and the special symbols "- _"' : ''
			let validationHeaderTextColor = ''// (formData.hosted_subdomain.match(regex_validator.subdomain)===null) ? 'Invalid subdomain, must only include letters, numbers and the special symbols "- _"' : ''
			// ! Check the syntaxe 
			if(formData?.background_color!=='' && formData?.background_color.match(regex_validator.colorHex)===null){
				validationBackgroundColor = 'Invalid color, you must only include numbers and the special symbol "#" at the beginning'  
			}
			if(formData?.header_text_color!=='' && formData?.header_text_color.match(regex_validator.colorHex)===null){
				validationHeaderTextColor = 'Invalid color, you must only include numbers and the special symbol "#" at the beginning'  
			}
			// if(formData.hosted_subdomain.match(regex_validator.subdomain)===null){
			// 	validationSubdomain = 'Invalid subdomain, must only include letters, numbers and the special symbols "- _"'  
				
			// }else{
			// 	validationSubdomain = 'The selected subdomain is not available!'
			// 	// ! Check the availability 
			// 	try {
			// 		const response = await checkSubdomainAvailability(formData.hosted_subdomain)
					
			// 		if(response && response?.availability === true ) validationSubdomain = '';
					

			// 	} catch (error) {}

				
			// }
			setFormValidation((prevState) => ({
				...prevState,
				background_color: validationBackgroundColor,
				header_text_color: validationHeaderTextColor
			}))

			if(validationBackgroundColor !=='' ){

				toast.error("Please complete all required fields")
				setIsLoading(false)

				return 
			}

			
			
			
			
			
			if (user && user.token && org && org?.id && formData?.id !==null ) {

				
				let params = { 
					background_color : formData?.background_color,
					header_text_color : formData?.header_text_color,
					logo : formData?.logo,
					favicon : formData?.favicon,
				}
				

				const token = user?.token;


				await axios.put(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

					setIsLoading(false)
					toast.success(`Your page's theme has been successfully updated`)

					updateReduxPageInfo(data);
					
		
					resolve(data.data) 
		
				})
				.catch(error => {
					//console.log(error)
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.error('Something went wrong, please try again later.')
					 
				})
			}else{
				setIsLoading(false)
				toast.error('Something went wrong, please try again later.')
				 
			}


		})

	}

	/**
	 * 
	 * @param {*} pageData 
	 * @returns 
	 */
	const updateReduxPageInfo = (data) => {

		// ! Update REDUX > ORG > STATUSPAGES [ ID ]
		dispatch(updateOrganizationPagesByID({
			statuspage_id : page_id ,
			data : {
				id : data?.id,
				name : data?.name,
				organization_legal_name : data?.organization_legal_name,
				website_url : data?.website_url,
				support_url : data?.support_url,
				created_at : data?.created_at,
				type : data?.type,
				custom_domain : data?.custom_domain,
				hosted_subdomain : data?.hosted_subdomain,
				logo : data?.logo,
				favicon : data?.favicon,
				is_active : data?.is_active,
				status : data?.status,
				background_color : data?.background_color,
				header_text_color : data?.header_text_color,
			}
		}))

		 // ! Update the status page in REDUX > AUTH > USER > ORGANIZATIONS > STAUSPAGES
		 dispatch(updateUserOrganizationPageByID({
			organization_id : org?.id ,
			statuspage_id : page_id,
			data : {
				id : data?.id,
				name : data?.name,
				organization_legal_name : data?.organization_legal_name,
				website_url : data?.website_url,
				support_url : data?.support_url,
				created_at : data?.created_at,
				type : data?.type,
				custom_domain : data?.custom_domain,
				hosted_subdomain : data?.hosted_subdomain,
				logo : data?.logo,
				favicon : data?.favicon,
				is_active : data?.is_active,
				status : data?.status,
				background_color : data?.background_color,
				header_text_color : data?.header_text_color,
			}
		}))
	}

	/**
	 * 
	 * @param {*} e 
	 */
	const onChange = (e) => {

		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: (e.target.type ==='checkbox') ? e.target.checked :  e.target.value,
		}));
	};
 

	return (
		<>
		<Helmet>
			<title>{`Theme - Page settings - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<form>
			{
				isLoadingStatuspageData === true 
				? 'Loading..'
				: (
					<>
					<div className="content-grid">
						<div className="grid-column">
							<Input
								label="Logo"
								placeholder="URL to company logo"
								name="logo"
								onChange={onChange}
								value={formData?.logo}
								error={formValidation?.logo}
								/>
							<Input
								label="Favicon"
								placeholder="URL to company favicon"
								name="favicon"
								onChange={onChange}
								value={formData?.favicon}
								error={formValidation?.favicon}
								/>
							<InputWrapper 
								label={`Background Color`}
								error={formValidation?.background_color} >
								<ColorPicker 
									defaultColor={formData?.background_color}
									onComplete={ ( color ) => {
										setFormData((prevState) => ({
											...prevState,
											background_color : color
										}))
									}} />
								
							</InputWrapper>
							<InputWrapper 
								label={`Header Text Color`}
								error={formValidation?.header_text_color} >
								<ColorPicker 
									defaultColor={formData?.header_text_color}
									onComplete={ ( color ) => {
										setFormData((prevState) => ({
											...prevState,
											header_text_color : color
										}))
									}} />
								
							</InputWrapper>
							
						</div>
						<div className="grid-column">
							<div className='preview-step-processing'>
								<div className="browserbar-wrapper">
									<Browserbar  />
									<div className="statuspage-favicon"><img src={formData?.favicon} /></div>
									<div className="statuspage-name">{formData?.name}</div>
									<div className="statuspage-url">
										<div className="preview-prefix">https://</div>
										<div className={`preview-subdomain  success`}>{formData?.custom_domain ?? formData?.subdomain}</div>
										{ formData?.custom_domain === null && <div className="preview-suffix">{process.env.REACT_APP_STATUSPAGE_HOSTNAME}</div> }
									</div>
								</div>
								<StatusPageContentDemo 
									name={formData?.name}
									url={`https://${formData?.subdomain}${process.env.REACT_APP_STATUSPAGE_HOSTNAME}`}
									logo={formData?.logo}
									background_color={formData?.background_color}
									header_text_color={formData?.header_text_color}
									components={[
										{   
                                            name : 'Component 1 ', 
                                            displayChart : true ,
                                            status : 'OPERATIONAL',
                                        } ,
										{   
                                            name : 'Component 2 ', 
                                            displayChart : true ,
                                            status : 'OPERATIONAL',
                                        } ,
										{   
                                            name : 'Component 3 ', 
                                            displayChart : false ,
                                            status : 'OPERATIONAL',
                                        } ,
									]?.map( (cp , i ) => ({
										name : cp?.name ,
										id : i,
										display_chart : cp?.displayChart ,
                                        status : cp.status,
                                        hideName : true ,

									}) )}
								/>
							</div>
						</div>
					</div>
					<div className="field-group submit-fields-group fluid form_fixed_footer">
						<Container className="flex-start">
                            <div   className='form_footer'   >
                               <Button  onClick={onSubmit}  loading={isLoading} >{'Save'}</Button>
                            </div>
                        </Container>
					</div>
					</>)
			}
		</form>	
		</>
	)
}
